import {observer} from "mobx-react";
import React from "react";
import themeState from "../state/themeState";
import unknownImg from "../images/photo_blank.png"
import experimentState, {ApplicationState} from "../state/experimentState";
import backend from "../backend";
import {shuffleArray} from "../data/questions";

import {create} from "random-seed";

const Phase2Screen = observer(
    class extends React.Component {

        constructor(props) {
            super(props);
            this.rand = create(experimentState.experimentParams.shuffle_seed)
            this.timeout = null
            this.iqQuestions = experimentState.renderIqQuestions(this.rand)

            this.state = this.initState()
        }

        transformQuestions(profileQuestions, amount) {
            let n_iq = 5
            let n_profile = 10
            // let n_iq = 1
            // let n_profile = 1
            profileQuestions = shuffleArray(profileQuestions,this.rand)
            let iqQuestions = shuffleArray(this.iqQuestions,this.rand)
            let qtype = (experimentState.experimentParams.lie)? "third" : "simple"
            return [iqQuestions[0],iqQuestions[1],...shuffleArray([
                ...iqQuestions.slice(2,n_iq),
                ...profileQuestions.filter(([_1, _2, _3, type, _4, _5], idx) => type === qtype).slice(0, n_profile).map(([qid, rid, text, shortness, positive, cr], idx) => {
                return {
                    header: "Ja of Nee",
                    body: text,
                    answers: ["ja", "nee"],
                    correct: (positive) ? "ja" : "nee",
                    forceCorrect: true
                }
            })],this.rand)]
        }

        initState(retry) {

            let questions = this.transformQuestions(this.props.questions.map(ele => ele), 2)
            let answers = questions.map(() => {
                return null
            })
            return {
                questions: questions,
                current: 0,
                answerGiven: false,
                answers: answers,
                retry: retry | false,
                onFinish: this.props.onFinish,
                showProfile: true
            }
        }

        onClick(evt) {
            let state = this.state
            if (state.answerGiven) {
                return
            } else if (state.showProfile) {
                state.showProfile = false
            } else {
                state.answerGiven = true
                state.answers[state.current] = evt.target.value
                if (this.timeout === null) {
                    setTimeout(() => {
                        this.move()
                    }, 1000)
                }

                backend.actionSendMessage(experimentState.useProfile.firstname, `Fase 2: finished question ${state.current} out of 15`)
            }
            this.setState(state)

        }

        move() {
            let state = this.state
            state.current += 1
            state.answerGiven = false
            if (state.current === state.questions.length) {
                if (state.answers.every((val,idx) => (val === this.state.questions[idx].correct) || !this.state.questions[idx].forceCorrect)) {
                    backend.actionSendMessage(experimentState.useProfile.firstname, "Finished fase 2")
                    state.onFinish(state.questions, state.answers)
                } else {
                    this.setState(this.initState(true))
                }
            } else {
                this.setState(state)
            }
        }

        render() {
            let section;
            let headertext;
            if (this.state.showProfile) {
                headertext = <h1>Dit bent u!</h1>
                section = <section style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                    {(this.state.retry) ? <div>U heeft een aantal vragen verkeerd beantwoord. <br/><br/>Om aan te tonen dat u het profiel goed kent moet je alle vragen correct beantwoorden.</div> : <div>Het volgende profiel is aan u toegewezen:</div>}
                    <div style={{display: "flex", gap: "16px"}}>

                        <img alt="Stylized human icon" style={{height: "200px", "width": "200px"}} src={experimentState.useProfile.photo}/>
                        <div style={{display: "flex", flexFlow: "column", gap: "8px"}}>
                            {experimentState.fields.filter(({hidden},idx) => !hidden).map(({label, id, displayFn, phase2Label}, idx) => {
                                if (displayFn === undefined) {
                                    displayFn = (v) => {
                                        return v
                                    }
                                }
                                return <div key={idx}>{phase2Label? phase2Label: label}: {displayFn(experimentState.useProfile[id])}</div>
                            })}
                        </div>
                    </div>
                    {this.state.retry ? "" : <div>Wij zullen vragen stellen over dit
                        profiel, {(experimentState.experimentParams.lie) ? "dus bestudeer het goed!" : "dus zorg dat het goed is ingevuld!"}</div>}
                    <div>Naast vragen over het profiel zullen we u ook een aantal (wiskundige) puzzels laten oplossen.</div>
                    <div>Het is de bedoeling dat <i>alle</i> vragen goed beantwoord worden voordat u door kan naar de volgende phase.</div>
                    <div>Zodra u klaar bent, klik op de knop hieronder.</div>
                    <button style={{backgroundColor: themeState.colour_primary, padding: "16px"}}
                            onClick={this.onClick.bind(this)}>Ik ben klaar voor de vragen
                    </button>
                    {!experimentState.experimentParams.lie? <button style={{backgroundColor: themeState.colour_secondary, padding: "16px"}}
                            onClick={() => {experimentState.setApplicationState(ApplicationState.APP_PHASE_1)}}>Het profiel klopt niet - opnieuw invullen</button> : null}
                </section>
            } else if (this.state.current >= this.state.questions.length) {
                section = <section>Er zijn geen vragen meer. Dit is een bug.</section>

            } else {

                headertext = <h1>Vraag {this.state.current + 1}/{this.state.questions.length}</h1>
                let q = this.state.questions[this.state.current]
                section = <section style={{display: "flex", flexDirection: "column"}}>
                    <div style={{marginTop: "32px"}}>{q.header}</div>
                    <pre style={{marginTop: "32px"}}>{q.body}</pre>
                    <div style={{display: "flex", justifyContent: "space-evenly", marginTop: "32px"}}>
                        {q.answers.map((txt, idx) => {
                            let backgroundIfGiven = (this.state.answerGiven) ? ((txt === q.correct) ? "green" : "red") : themeState.colour_primary
                            return <button key={idx} value={txt} id={"answer_" + idx} onClick={this.onClick.bind(this)}
                                           style={{padding: "16px", backgroundColor: backgroundIfGiven}}>{txt}</button>
                        })}
                    </div>
                </section>
            }
            return <div>
                <header className="header" style={{backgroundColor: themeState.colour_primary}}>
                    {headertext}</header>
                {section}
            </div>
        }
    }
)

export default Phase2Screen